import axios from "axios";
import AuthService from "../../services/login/auth.service";
import { cuentas, comprobantes } from "../../components/generico/utils/UrlAPI";



//var idPersona = AuthService.getSocio()===undefined ? "-":AuthService.getSocio().idPersona.trim();
//var idPersona ="0";

class HabilitarAhorroProgramadoService {
  async obtenerListadoCuentasAhorro() {
    var config = {
      method: "get",
      url:
        cuentas + "autogestion",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };

    return await axios(config);
  }

  async aperturaCuentaAhorroProgramado(data) {
    var config = {
      method: "post",
      url:
        cuentas + "ahorro-programado",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async descargarContrato(nombreSocio, ciSocio, nroSocio, domicilioSocio, telefSocio,
    nroCuenta, importeCuota, plazo, fechaVigencia, fechaApertura = null) {

    var _url = comprobantes + "comprobantes/v2/contrato-ahorro-programado";

    var mesLetras = new Map();
    mesLetras.set(1, "enero"); mesLetras.set(2, "febrero"); mesLetras.set(3, "marzo");
    mesLetras.set(4, "abril"); mesLetras.set(5, "mayo"); mesLetras.set(6, "junio");
    mesLetras.set(7, "julio"); mesLetras.set(8, "agosto"); mesLetras.set(9, "setiembre");
    mesLetras.set(10, "octubre"); mesLetras.set(11, "noviembre"); mesLetras.set(12, "diciembre");

    var today = new Date();
    var dd = String(today.getDate());
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    var fecha = "";

    if(fechaApertura === null){
      fecha = dd + " días del mes de " + mesLetras.get(mm) + " del " + yyyy;
    }else{
      
      let fechaAperturaSplit = fechaApertura.split("/");
      let dia = parseInt(fechaAperturaSplit[0]);
      let mes = mesLetras.get(parseInt(fechaAperturaSplit[1]));
      let anho = fechaAperturaSplit[2];

      fecha = `${dia} días del mes de ${mes} del ${anho}`;

    }

    var fechaVigenciaSplit = fechaVigencia.split("/"); // separamos dd, mm, yyyy

    var data = JSON.stringify({
      nombreSocio: nombreSocio,
      ciSocio: ciSocio,
      nroSocio: nroSocio,
      domicilioSocio: domicilioSocio,
      telefSocio: telefSocio,
      nroCuenta: nroCuenta,
      importeCuota: importeCuota,
      plazo: plazo,
      fechaVigencia: fechaVigenciaSplit[0] + " de " + mesLetras.get(parseInt(fechaVigenciaSplit[1])) + " del " + fechaVigenciaSplit[2],
      fecha: fecha
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async descargarContratoMeta(idAhorro) {

    var _url = cuentas + 'ahorro-programado/get-contrato-ahorro-prog-tm';

    
    var data = JSON.stringify({
      idAhorro: idAhorro});

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async descargarComprobanteMeta(data) {

    var _url = comprobantes + '/comprobantes/impresion-transferencia-cuentas-propias';
   // var _url = 'http://localhost:8080/comprobantes/impresion-transferencia-cuentas-propias';
    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async getCuentas(tipo) {
    var data = JSON.stringify({
      canal: "WEB",
      estado: null,
      modalidad: null,
      moneda: "GS",
      tipo: tipo,
      tipoCuenta: null
    });

    var config = {
      method: "post",
      url: cuentas + "socio-cuenta/transferencias",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async obtenerPlanesAhorro() {

    var config = {
      method: "get",
      url: cuentas + "ahorro-programado",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      }
    };

    return await axios(config);
  }
   async getInteres(data) {
    var config = {
      method: "post",
       url: cuentas + "ahorro-programado/calcularInteresTuMeta",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }
  
}
export default new HabilitarAhorroProgramadoService();
